import { useContext } from "react";
import PathVariablesContext from "../libs/router/PathVariables";
export default function usePathVariables() {
    const context = useContext(PathVariablesContext);
    return context;
}
